import React, { useState } from 'react';

export interface FallbackImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallbackImage: string;
}

export const FallbackImage: React.FC<FallbackImageProps> = ({ fallbackImage, src, ...props }) => {
  // fallback image should only be defined if there's an error loading the original image
  const [fallbackImgSrc, setFallbackImgSrc] = useState<string | undefined>(undefined);
  const imgSrc = fallbackImgSrc || src;
  return <img {...props} onError={() => setFallbackImgSrc(fallbackImage)} src={imgSrc} />;
};
